import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { TuiRadioListModule } from "@taiga-ui/kit";
import { KwikUISafeHtmlPipeModule } from "../../../../pipes/safe-html/safe-html.module";
import { KwikUIInputRadioComponent } from "./input-radio.component";

@NgModule({
  declarations: [KwikUIInputRadioComponent],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    TuiRadioListModule,
    KwikUISafeHtmlPipeModule
  ],
  exports: [KwikUIInputRadioComponent]
})
export class KwikUIInputRadioModule {}
